"use strict";

var _classCallCheck = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _require = require('preact'),
    h = _require.h,
    Component = _require.Component;

var classNames = require('classnames');

var shallowEqual = require('is-shallow-equal');

var FilePreviewAndLink = require('./FilePreviewAndLink');

var FileProgress = require('./FileProgress');

var FileInfo = require('./FileInfo');

var Buttons = require('./Buttons');

module.exports = /*#__PURE__*/function (_Component) {
  _inherits(FileItem, _Component);

  var _super = _createSuper(FileItem);

  function FileItem() {
    _classCallCheck(this, FileItem);

    return _super.apply(this, arguments);
  }

  _createClass(FileItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var file = this.props.file;

      if (!file.preview) {
        this.props.handleRequestThumbnail(file);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !shallowEqual(this.props, nextProps);
    } // VirtualList mounts FileItems again and they emit `thumbnail:request`
    // Otherwise thumbnails are broken or missing after Golden Retriever restores files

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var file = this.props.file;

      if (!file.preview) {
        this.props.handleRequestThumbnail(file);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var file = this.props.file;

      if (!file.preview) {
        this.props.handleCancelThumbnail(file);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var file = this.props.file;
      var isProcessing = file.progress.preprocess || file.progress.postprocess;
      var isUploaded = file.progress.uploadComplete && !isProcessing && !file.error;
      var uploadInProgressOrComplete = file.progress.uploadStarted || isProcessing;
      var uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
      var error = file.error || false; // File that Golden Retriever was able to partly restore (only meta, not blob),
      // users still need to re-add it, so it’s a ghost

      var isGhost = file.isGhost;
      var showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;

      if (isUploaded && this.props.showRemoveButtonAfterComplete) {
        showRemoveButton = true;
      }

      var dashboardItemClass = classNames({
        'uppy-Dashboard-Item': true,
        'is-inprogress': uploadInProgress && !this.props.recoveredState,
        'is-processing': isProcessing,
        'is-complete': isUploaded,
        'is-error': !!error,
        'is-resumable': this.props.resumableUploads,
        'is-noIndividualCancellation': !this.props.individualCancellation,
        'is-ghost': isGhost
      });
      return h("div", {
        className: dashboardItemClass,
        id: "uppy_".concat(file.id),
        role: this.props.role
      }, h("div", {
        className: "uppy-Dashboard-Item-preview"
      }, h(FilePreviewAndLink, {
        file: file,
        showLinkToFileUploadResult: this.props.showLinkToFileUploadResult
      }), h(FileProgress, {
        uppy: this.props.uppy,
        file: file,
        error: error,
        isUploaded: isUploaded,
        hideRetryButton: this.props.hideRetryButton,
        hideCancelButton: this.props.hideCancelButton,
        hidePauseResumeButton: this.props.hidePauseResumeButton,
        recoveredState: this.props.recoveredState,
        showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete,
        resumableUploads: this.props.resumableUploads,
        individualCancellation: this.props.individualCancellation,
        i18n: this.props.i18n
      })), h("div", {
        className: "uppy-Dashboard-Item-fileInfoAndButtons"
      }, h(FileInfo, {
        file: file,
        id: this.props.id,
        acquirers: this.props.acquirers,
        containerWidth: this.props.containerWidth,
        i18n: this.props.i18n,
        toggleAddFilesPanel: this.props.toggleAddFilesPanel
      }), h(Buttons, {
        file: file,
        metaFields: this.props.metaFields,
        showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
        showRemoveButton: showRemoveButton,
        canEditFile: this.props.canEditFile,
        uploadInProgressOrComplete: uploadInProgressOrComplete,
        toggleFileCard: this.props.toggleFileCard,
        openFileEditor: this.props.openFileEditor,
        uppy: this.props.uppy,
        i18n: this.props.i18n
      })));
    }
  }]);

  return FileItem;
}(Component);